import styled from 'styled-components';

export const QuantityWrapper = styled.div<any>`
  background-color: ${({ isProductDetails }) => (isProductDetails ? '#43a047' : '#F5F5F4')};
  border-radius: ${({ isProductDetails }) => (isProductDetails ? '10px' : '6px')};
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  padding: ${({ isProductDetails }) => (isProductDetails ? '2px' : '1px')};
  gap: 4px;
  height: ${({ size, isProductDetails }) => (size === 'small' ? (isProductDetails ? '32px' : '30px') : '40px')};
`;
